import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ShiftHistoryComponent } from './shift-history.component';
import { IconSvgModule } from '@web-frontend/common/components/iconSvg/iconSvg.module';

@NgModule({
  declarations: [ShiftHistoryComponent],
  imports: [CommonModule, TranslateModule.forChild(), IconSvgModule],
  exports: [ShiftHistoryComponent],
})
export class ShiftHistoryModule {}
